// ============================================================================
// RUSSIAN TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "Единство, Производящее Мир",
    author: "Автор: Emmanuel",
    subtitle: "У каждой религии есть свои причины, наши границы пришли из прошлого",
    description: "Модуль размышлений о духовном единстве и мире между традициями",
    
    nav: {
      intro: "Вступление",
      religions: "Религии",
      common: "Общие Основы",
      humility: "Смирение"
    },

    intro: {
      emmanuelSays: "Emmanuel говорит:",
      ourBordersFromPast: "Наши границы пришли из прошлого",
      bordersDescription: "У каждой религии есть свои причины. Наши разделения - не воля Божья, а плод истории, географии, культуры.",
      divisionWork: "Разделение, изоляция через барьеры и границы страха - это дело нашего опасного прошлого.",
      sharedHumanity: "Мы родились в разных традициях, но разделяем одну человечность.",
      
      revelationTitle: "Откровение, открывающее глаза",
      surprisedLearning: "Я был удивлен однажды, узнав, что евреи тоже дети Божьи.",
      angelMichael: "Что ангел Михаил - великий посланник для мусульман.",
      jesusNames: "Что Иисус, Иса, Йешуа известны по-разному, даже в христианской вере.",
      diverseTribes: "Потому что существуют разные племена, разные церкви, разные семьи.",
      sameRealities: "Мы говорим об одних и тех же реальностях разными именами. Это должно нас сближать, а не разделять.",
      
      respectTitle: "Уважение: основа смирения, страж мира",
      respectFoundation: "Даже если братство объективно неприменимо, уважение - это основа смирения, страж мира.",
      understandingProcess: "Понимать и уважать другие религии - это процесс смирения. Это не значит отказываться от своей веры, но принимать, что другой тоже ищет истину.",
      
      whatBindsUs: "Что действительно нас связывает",
      seekingRelation: "Каждая религия ищет отношений. Каждый человек ищет мира.",
      loveOfGod: "Эти отношения, что связывают нас всех, - это любовь Божья.",
      universalLink: "Любовь - это универсальная связь, которая превосходит все границы, все языки, все традиции.",
      
      inclusionTitle: "Включение: еще более обширное, чем религиозное разнообразие",
      vastInclusion: "Религиозное разнообразие обширно, но еще более обширно включение других там, где они призваны Богом.",
      respectDifferences: "Уважение к различиям цвета, пола, включение делает нас уникальными людьми, любимыми Богом.",
      jesusCommand: "Иисус сказал: 'Любите друг друга.'",
      
      communitySpirit: "Порвать с духом общинности",
      communityTerror: "Общинность - это террор ненависти зла, замаскированного. Она превращает веру в племенную идентичность, в стену, которая разделяет, в оружие, которое ранит.",
      pridePolitics: "Наши партийные духи толкают нас к политике гордыни:",
      prideQuotes: "Я прав, причиняя тебе боль. Я прав, и точка. Я прав, ведя справедливую войну.",
      watchHeart: "Обратите внимание на сердце проблемы, на корень нашего собственного зла.",
      refuseDivision: "Откажемся от этого дрейфа, который разделяет человечество во имя Бога.",
      
      freedomTitle: "Чтобы быть свободным, освободи других",
      freedomOthers: "Чтобы быть свободным, нужно уметь освобождать и других.",
      defendFreedom: "Моя свобода верить имеет ценность только если я защищаю свободу всех. Угнетать другого - значит обречь себя на рабство.",
      
      changeHeartTitle: "Измени свое сердце: будь настоящим фонарем",
      recognizeDecency: "Признать, что приличие не одинаково для каждого.",
      changeYourself: "Изменение себя сначала, постепенно. Измени свое сердце, преобрази свою жизнь, будь настоящим фонарем.",
      beExample: "Не писай на траве, потому что она погибнет... Не навязывай свои правила другим, но стань живым примером через свою трансформацию.",
      
      childrenPeaceTitle: "Наши дети будут жить в мире в разнообразии",
      avoidPursuit: "Избегать преследования слов за словами.",
      peaceChoice: "Если мы выберем уважение сегодня, наши дети будущего будут жить в мире в разнообразии. Мир начинается с нас, сейчас, в наших словах и действиях.",
      
      discernTitle: "Различать: человек или Бог?",
      manSpeaks: "Слишком часто говорит сердце человека и разделяет.",
      seeFruits: "Это видно по плодам слов: воровство, разрушение, войны. Берегитесь манипуляции словами для своей гордыни.",
      
      lookPeaceTitle: "Смотреть на мир и любовь",
      lookPeaceAll: "Смотреть на мир для всех, смотреть на любовь Бога к другим.",
      godSpeaks: "Когда слова производят мир, примирение, единство: это Бог говорит. Когда они производят разделение, ненависть, войну: это гордыня человека.",
      
      watchWordsTitle: "Следить за нашими словами",
      watchShares: "Следить за нашими делами, следить за нашими вредными словами против других.",
      disqualify: "Эти злодеяния дисквалифицируют нас самих. Плоды наших слов раскрывают, кто говорит в нас: Бог или наша собственная гордыня?",
      
      wisdomMaturityTitle: "Мудрость и зрелость перед лицом нашей природы",
      useScriptures: "Использовать писания (законы) для причинения вреда - наша привычка, почти естественный и коварный процесс.",
      hateSin: "Столкнувшись с нашей греховной природой, мы ненавидим зло и людей, которые делают зло.",
      separateActs: "Но мудростью и зрелостью нужно отделить действия от нашей человеческой бедности.",
      compassionNature: "Признать нашу животную природу, которая нуждается в сострадании и благодати, защищаясь в соответствии с контекстами.",
      
      denounceLeadersTitle: "Осудить коррумпированных духовных лидеров",
      watchLeaders: "Берегитесь духовных лидеров или руководителей, которые стремятся сохранить в секрете свой упадок и нечестность.",
      noJustice: "Без справедливости нет примера. Без знания другие жертвы погибают из-за нашего молчания.",
      silenceComplicity: "Молчание перед лицом несправедливости - это соучастие. Истина должна быть сказана, чтобы защитить других."
    },

    religions: {
      title: "Различные Религии, одно Человечество",
      intro: "Христиане, Мусульмане, Иудеи, Индуисты, Буддисты... и многие другие: все ищут истину",
      theirGod: "Их Бог:",
      theGood: "Добро:",
      theEvil: "Зло:",
      theAngels: "Ангелы:",
      theUnity: "Единство:",
      values: "Ценности:",
    commonGoal: "Общая Цель",
    seekingPeace: "Все религии разделяют общую цель: искать мир, продвигать любовь и строить лучший мир. За пределами наших различий мы все объединены в этом поиске мудрости и гармонии.",
      
      christianity: {
        name: "Христианство",
        godText: "Единый Бог, Отец-создатель",
        goodText: "Любовь к ближнему, прощение, мир",
        evilText: "Ненависть, эгоизм, насилие",
        angelsText: "Посланники Бога (Гавриил, Михаил...)",
        unityText: "Один Бог для всех людей",
        values: "Любовь,Прощение,Мир,Смирение,Справедливость"
      },
      islam: {
        name: "Ислам",
        godText: "Аллах, Единственный и Милосердный",
        goodText: "Справедливость, милосердие, мир",
        evilText: "Угнетение, ложь, разделение",
        angelsText: "Ангелы света (Джибриль, Микаил...)",
        unityText: "Нет бога, кроме Аллаха",
        values: "Мир,Справедливость,Милосердие,Уважение,Милость"
      },
      judaism: {
        name: "Иудаизм",
        godText: "ЯХВЕ, Вечный единый",
        goodText: "Справедливость, сострадание, жизнь",
        evilText: "Угнетение, клевета, ненависть",
        angelsText: "Небесные посланники (Малахим)",
        unityText: "Слушай, Израиль, Господь един",
        values: "Справедливость,Жизнь,Память,Мир,Учение"
      },
      hinduism: {
        name: "Индуизм",
        godText: "Брахман, высшая реальность",
        goodText: "Ненасилие (ахимса), праведный долг",
        evilText: "Насилие, духовное невежество",
        angelsText: "Дэвы, благожелательные небесные существа",
        unityText: "Всё едино в Брахмане",
        values: "Ненасилие,Истина,Сострадание,Чистота,Гармония"
      },
      buddhism: {
        name: "Буддизм",
        godText: "Нет бога-создателя, но уважение к священному",
        goodText: "Сострадание, мудрость, мир",
        evilText: "Страдание, вызванное невежеством",
        angelsText: "Бодхисаттвы, просветленные существа",
        unityText: "Природа Будды в каждом",
        values: "Сострадание,Мудрость,Мир,Ненасилие,Пробуждение"
      }
    },

    common: {
      title: "Общие Основы",
      intro: "Добро, Зло, Ангелы, Единый Бог, Отношения, Включение: что объединяет человечество",
      
      goodTitle: "Добро",
      goodDescription: "Все религии учат любви, справедливости и состраданию",
      goodExamples: "Любить ближнего как самого себя|Делать добро без различия|Защищать слабых и угнетенных|Говорить правду с добротой|Делиться тем, что имеешь",
      
      evilTitle: "Зло",
      evilDescription: "Все осуждают насилие, ложь и угнетение",
      evilExamples: "Убивать без справедливости|Красть и эксплуатировать|Лгать и клеветать|Презирать и унижать|Разделять и ненавидеть",
      
      angelsTitle: "Ангелы и Духовные Существа",
      angelsDescription: "Почти все признают благожелательных небесных посланников",
      angelsExamples: "Ангелы-посланники Бога|Духовные проводники|Существа света|Небесные защитники|Бодхисаттвы и Дэвы",
      
      godTitle: "Единый Бог (или Высшая Реальность)",
      godDescription: "Большинство верит в единственный источник, создателя или конечную реальность",
      godExamples: "Христианство, Ислам, Иудаизм: Единый Бог|Индуизм: Брахман, высший Единый|Буддизм: Универсальная природа Будды|Все ищут конечную истину|Все стремятся к единству и миру",
      
      relationTitle: "Отношения и Мир",
      relationDescription: "Что действительно объединяет все религии и всех людей",
      relationExamples: "Каждая религия ищет отношений с божественным|Каждый человек ищет мира|Эти отношения, что связывают нас всех, - это любовь Божья|Любовь - это универсальная связь|Мир - это наше общее стремление",
      
      inclusionTitle: "Включение: Любимые Богом",
      inclusionDescription: "Религиозное разнообразие обширно, но еще более обширно включение",
      inclusionExamples: "Включение других там, где они призваны Богом|Уважение к различиям цвета|Уважение к различиям пола|Включение делает нас уникальными людьми, любимыми Богом|Иисус сказал: 'Любите друг друга'",
      
      finalQuote: "Я был удивлен однажды, узнав, что евреи тоже дети Божьи, что ангел Михаил - великий посланник для мусульман, что Иисус, Иса, Йешуа известны по-разному даже в христианской вере. Потому что существуют разные племена, разные церкви, разные семьи.",
      finalQuote2: "Мы говорим об одних и тех же реальностях разными именами.",
      quoteAuthor: "Emmanuel, Единство, Производящее Мир"
    },

    humility: {
      title: "7 Шагов к Смирению и Миру",
      intro: "Процесс преодоления общинности и становления настоящим фонарем",
      
      step: "Шаг",
      action: "Действие:",
      
      step1Title: "Признать: наши границы пришли из прошлого",
      step1Description: "Разделение, изоляция через барьеры и границы страха - это дело нашего опасного прошлого. Наши разделения - не воля Божья.",
      step1Action: "Принять, что моя традиция только моя, и я часть разнообразия, желаемого Богом",
      
      step2Title: "Уважение: основа смирения, страж мира",
      step2Description: "Даже если братство объективно неприменимо, уважение - это основание.",
      step2Action: "Уважать все верования, даже не понимая всего",
      
      step3Title: "Понимать без осуждения",
      step3Description: "Сегодня понимание других - это необходимый процесс смирения.",
      step3Action: "Действительно слушать, во что верят другие, без осуждения",
      
      step4Title: "Изменение себя сначала: будь настоящим фонарем",
      step4Description: "Признать, что приличие не одинаково для каждого. Измени свое сердце постепенно, преобрази свою жизнь, стань настоящим светом.",
      step4Action: "Не навязывать свои правила другим, но быть живым примером через свою трансформацию",
      
      step5Title: "Порвать с духом общинности",
      step5Description: "Наши партийные духи толкают нас к политике гордыни: 'Я прав, причиняя тебе боль, я прав, и точка.' Обратите внимание на сердце проблемы, на корень нашего собственного зла.",
      step5Action: "Отказаться от речей разделения в моей собственной общине",
      
      step6Title: "Чтобы быть свободным, освободи других",
      step6Description: "Моя свобода зависит от той, что я даю другим.",
      step6Action: "Защищать свободу совести всех, а не только мою",
      
      step7Title: "Избегать преследования слов за словами",
      step7Description: "Не отвечать ненавистью на ненависть, оскорблениями на оскорбления.",
      step7Action: "Выбрать мир, чтобы наши дети жили в мире в разнообразии",
      
      discernFruits: "Различать по Плодам",
      humanHeart: "Сердце человека, которое разделяет",
      lookGodLove: "Смотреть на любовь Бога",
      watchOurWords: "Следить за нашими Словами",
      
      prideFruits: "Плоды человеческой гордыни",
      prideFruitsList: "Дух партийности: \"Я прав, точка\"|Политика гордыни: \"Я прав, причиняя тебе боль\"|Использование писаний для причинения вреда (лукавый процесс)|Ненависть к людям (а не только к поступкам)|Духовные лидеры, скрывающие свой отход и нечестность|Молчаливое соучастие перед лицом несправедливости|Разделение и войны|Ненависть, замаскированная под благочестие|Воровство и разрушение|Манипуляция ради гордыни|Презрение и насилие",
      
      godFruits: "Плоды любви Бога",
      godFruitsList: "Разделение поступков и личности с мудростью|Сострадание к нашей человеческой бедности|Благодать, защищая себя в соответствии с контекстом|Обличение несправедливости для защиты других|Говорение истины с мужеством|Мир для всех|Любовь без различия|Примирение и единство|Смирение и уважение|Свобода для всех",
      
      finalQuote: "Даже если братство объективно неприменимо, уважение - это основа смирения, страж мира. Избегать преследования слов за словами, и наши дети будущего будут жить в мире в разнообразии.",
      author: "Emmanuel"
    },

    footer: {
      quote: "Уважение - это основа смирения, страж мира. Наши дети будут жить в мире в разнообразии, если мы выберем уважение сегодня.",
      author: "Emmanuel, Единство, Производящее Мир"
    }
};

export default unityTranslations;
